import { BaseComponent, BElement } from "utils/base-component"
import type { ExperimentAnalyticsParams } from "utils/experiment-analytics"
import {
  experimentParamsFromElement,
  trackExperimentExposure,
  trackExperimentInteraction,
} from "utils/experiment-analytics"
import "./index.scss"

require.context("./static", false, /\.(svg|webp)$/)

const APP_PROMO_MODAL_EXPERIMENT_ID = "app_promo_modal"

export class ModalAppPopup extends BaseComponent {
  static cssClass = "modal-app-popup"
  private static closedCookie = "appPopupClosed=1"

  private close!: BElement
  private open!: BElement
  private actionTracked = false
  private experiment!: ExperimentAnalyticsParams

  init() {
    const closeElement = this.element("close-button")
    if (!closeElement) {
      throw new Error("Close button not found")
    }
    const openElement = this.element("open-button")
    if (!openElement) {
      throw new Error("Open button not found")
    }

    this.close = closeElement
    this.open = openElement

    this.experiment = experimentParamsFromElement(this.root, {
      experimentId: APP_PROMO_MODAL_EXPERIMENT_ID,
      experimentVariant: "unknown",
    })

    const isClosed = document.cookie.indexOf(ModalAppPopup.closedCookie) !== -1
    this.toggleModifier("closed", isClosed)
    this.toggleScrollLock(!isClosed)

    if (isClosed) {
      return
    }
    this.trackShown()

    const closePopup = (action?: string) => {
      this.trackAction(action)

      const expiryDate = new Date()
      expiryDate.setMonth(expiryDate.getMonth() + 1)

      document.cookie = `appPopupClosed=1; expires=${expiryDate.toUTCString()}; path=/`
      this.toggleModifier("closed", true)
      this.toggleScrollLock(false)
    }

    this.root.addEventListener("click", (e) => {
      if (e.target === this.root) {
        closePopup("dismiss_backdrop")
      }
    })

    this.close.element.addEventListener("click", (e) => {
      e.preventDefault()
      closePopup(this.close.element.dataset.experimentAction)
    })

    this.open.element.addEventListener("click", () => {
      closePopup(this.open.element.dataset.experimentAction)
    })
  }

  private trackAction(action?: string) {
    if (!action || this.actionTracked) {
      return
    }

    this.actionTracked = true
    this.trackInteraction(action)
  }

  private trackShown() {
    trackExperimentExposure({
      ...this.experiment,
    })
  }

  private trackInteraction(experimentAction: string) {
    trackExperimentInteraction({
      ...this.experiment,
      experimentAction,
    })
  }

  private toggleScrollLock(force: boolean) {
    const scrollLockModifier = this.modifierClassName("scroll-lock")
    document.documentElement.classList.toggle(scrollLockModifier, force)
  }
}
